// Protected Route Component - Nur für authentifizierte User

import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, loading } = useAuth();

  // Warten bis User-Daten geladen sind
  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh'
      }}>
        <div>Laden...</div>
      </div>
    );
  }

  // Nicht authentifiziert? -> Redirect zu Login
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Authentifiziert -> Zeige geschützten Content
  return <>{children}</>;
}
